module.exports = __webpack_public_path__ + "img/icon-date.f3e5b1eb.svg";